const PLACEHOLDER_EMAIL_DOMAIN = '@noemail.waterlily.internal';

export function isPlaceholderEmail(email: string | undefined | null): boolean {
  return !!email && email.endsWith(PLACEHOLDER_EMAIL_DOMAIN);
}
